const getPreloadElementId = (linkId: string) =>
    `${linkId}-preload`;

const getLinkElement = (linkId: string, preload = false) =>
    document.getElementById(preload ? getPreloadElementId(linkId) : linkId) as HTMLLinkElement;

const updateLinkUrl = (linkElement: HTMLElement, linkUrl: string) =>
    linkElement.setAttribute('href', linkUrl);


const createLinkElement = (linkId: string, linkUrl: string, preload = false) => {
    const linkElement = document.createElement('link');
    linkElement.setAttribute('href', linkUrl);

    if (preload) {
        linkElement.setAttribute('id', getPreloadElementId(linkId));
        linkElement.setAttribute('as', 'style');
        linkElement.setAttribute('rel', 'preload');
    } else {
        linkElement.setAttribute('id', linkId);
        linkElement.setAttribute('type', 'text/css');
        linkElement.setAttribute('rel', 'stylesheet');
    }

    return linkElement;
};

const manageLink = (linkId: string, linkUrl: string) => {
    let linkElement = getLinkElement(linkId);
    const shouldCreateElement = !linkElement;
    const shouldUpdateElement = !!(linkElement && linkElement.getAttribute('href') !== linkUrl);

    if (shouldCreateElement) {
        linkElement = createLinkElement(linkId, linkUrl);
        document.head.appendChild(linkElement);
        return;
    } else if (!shouldUpdateElement) {
        return;
    }
    const updateLink = () => updateLinkUrl(linkElement, linkUrl);

    if (!linkElement.relList?.supports('preload')) {
        updateLink();
        return;
    }

    let linkPreloadElement = getLinkElement(linkId, true);
    const shouldCreatePreloadElement = !linkPreloadElement;
    const shouldUpdatePreloadElement = !!(linkPreloadElement && linkPreloadElement.getAttribute('href') !== linkUrl);

    if (shouldUpdatePreloadElement) {
        updateLinkUrl(linkPreloadElement, linkUrl);
    } else if (shouldCreatePreloadElement) {
        linkPreloadElement = createLinkElement(linkId, linkUrl, true);
        document.head.appendChild(linkPreloadElement);
    }

    // Если прелоад обновили или создали, то саму линку добавляем после загрузки прелоада
    if (shouldUpdatePreloadElement || shouldCreatePreloadElement) {
        linkPreloadElement.onload = updateLink;
    } else {
        // Если прелоад уже есть и обновлять его не надо, мы предполагаем, что он уже загружен, и обновляем главную линку
        updateLink();
    }
};

function activate(element: HTMLElement) {
    const url = element.getAttribute('data-url');
    const linkId = element.getAttribute('data-link-id');

    if (!url || !linkId) {
        return;
    }

    manageLink(linkId, url);
}

export {
    activate
};
